
import * as defaultImport from "@splunk/react-icons/SVGEnterprise";
export * from "@splunk/react-icons/SVGEnterprise";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
